import React, {useEffect, useState} from 'react';
import './MobileTopNavigation.scss'
import LanguageSelector from "../LanguageSelector";
import UserDropDown from "../UserDropDown";
import {useDispatch, useSelector} from "react-redux";
import {getLoggedUser} from "../../store/actions/usersActions";
import {ReactComponent as HamburgerIcon} from "../../assets/icons/hamburger.svg";
import SideBar from "./SideBar";

const selector = state => {
    const { users } = state;
    return {
        loggedUser: users.loggedUser
    }
};

const MobileTopNavigation = props => {
    const {loggedUser} = useSelector(selector);
    const dispatch = useDispatch();

    const [mobileSideBar, setMobileSideBar] = useState(false);

    useEffect(() => {
        dispatch(getLoggedUser());
    }, []);

    return (
        <>
            <div className="MobileTopNavigation">
                <div onClick={() => setMobileSideBar(!mobileSideBar)} className="hamburgerContainer">
                    <HamburgerIcon />
                </div>
                <div className="rightSideContainer">
                    <div className="languageSelector">
                        <LanguageSelector />
                    </div>
                    <div className="userIconContainer">
                        <UserDropDown
                            responsive
                            user={loggedUser}
                        />
                    </div>
                </div>
            </div>
            {mobileSideBar && (
                <SideBar
                    responsive
                />
            )}
        </>
    )
}

export default MobileTopNavigation
